import { createDeleteDeviceDetailedModel } from 'features/delete-device';
import { createEditDeviceDetailedModel } from 'features/edit-device';
import { createDeviceRegistryModel } from 'entities/device';
import { cashdeskPageModel } from './cashdesk-page-model';

const deleteDeviceModel = createDeleteDeviceDetailedModel();

const editDeviceModel = createEditDeviceDetailedModel();

const deviceRegistryModel = createDeviceRegistryModel({
	$currencies: cashdeskPageModel.$cashdesk.map((cashdesk) => (cashdesk ? [cashdesk.currency] : [])),
	$cashdeskId: cashdeskPageModel.$cashdesk.map((cashdesk) => cashdesk?.id ?? null),
	$accountId: cashdeskPageModel.$cashdesk.map((cashdesk) => cashdesk?.account.id ?? null),
	onUpdate: [editDeviceModel.editDeviceDetailedMutation.finished.success],
	onDelete: [deleteDeviceModel.mutation.finished.success],
});

export const cashdeskPageDevicesModel = {
	deviceRegistryModel,
	deleteDeviceModel,
	editDeviceModel,
};
